export default {"src":"/_next/static/media/admin-user.9cd7237e.svg","height":208,"width":456,"blurWidth":0,"blurHeight":0};